export enum ActionEnum {
  LOAD_FILTER = "load_filter",
  CHANGE_MORE_FILTER = "change_more_filter",
  UPDATE_FILTER = "update_filter",
  REMOVE_FILTER = "remove_filter",
  EMPTY = "",
}
